import * as type from '../types/registration'

export const requestGeneralRegistrationValidation = payload => {
    return{
        type: type.REQUEST_GENERAL_VERIFICATION,
        details: payload
    }
}

export const resetGeneralRegistrationValidation = () => {
    return{
        type: type.RESET_GENERAL_VERIFICATION
    }
}

export const requestFinalizeRegistration = payload => {
    return{
        type: type.REQUEST_FINALIZE_REGISTRATION,
        details: payload
    }
}

export const resetFinalizeRegistration = () => {
    return{
        type: type.RESET_FINALIZE_REGISTRATION
    }
}

export const requestCanRegister = payload => {
    return{
        type: type.REQUEST_CAN_REGISTER,
        details: payload
    }
}

export const setCanRegister = () => {
    return{
        type: type.GRANT_CAN_REGISTER,
    }
}

export const resetCanRegister = () => {
    return{
        type: type.RESET_CAN_REGISTER
    }
}

export const requestInvitationRegistration = payload => {
    return{
        type: type.REQUEST_INVITATION_REGISTRATION,
        details: payload
    }
}

export const resetInvitationRegistration = () => {
    return{
        type: type.RESET_INVITATION_REGISTRATION
    }
}

export const requestNewSpaceRegistration = payload => {
    return{
        type: type.REQUEST_NEW_SPACE_REGISTRATION,
        details: payload
    }
}

export const resetNewSpaceRegistration = () => {
    return{
        type: type.RESET_NEW_SPACE_REGISTRATION
    }
}

export const requestFinalizeResubscription = payload => {
    return{
        type: type.REQUEST_RESUBSCRIBE_REGISTRATION,
        details: payload
    }
}

export const resetFinalizeReSubscription = () => {
    return{
        type: type.RESET_RESUBSCRIBE_REGISTRATION
    }
}